import FeatureNav from 'libs/feature-nav';
import Block from '../../../common/course/block_syllabus/blocks/block';
import TextBlock from '../../../common/course/block_syllabus/blocks/text-block';
import TitleBlock from '../../../common/course/block_syllabus/blocks/title-block';
import SpacerBlock from '../../../common/course/block_syllabus/blocks/spacer-block';
import ImageBlock from '../../../common/course/block_syllabus/blocks/image-block';
import PdfBlock from '../../../common/course/block_syllabus/blocks/pdf-block';
import VideoBlock from '../../../common/course/block_syllabus/blocks/video-block';
import AudioBlock from '../../../common/course/block_syllabus/blocks/audio-block';
import GradingPolicyBlock from '../../../common/course/block_syllabus/blocks/grading-policy-block';
import SessionListBlock from '../../../common/course/block_syllabus/blocks/session-list-block';
import CourseworkListBlock from '../../../common/course/block_syllabus/blocks/coursework-list-block';
import InstructorsListBlock from '../../../common/course/block_syllabus/blocks/instructors-list-block';
import CoursePromoBlock from '../../../common/course/block_syllabus/blocks/course-promo-block';
import CourseLogoBlock from '../../../common/course/block_syllabus/blocks/course-logo-block';
import SyllabusBlockPicker from './components/syllabus-block-picker'; 
import Draggable from 'vuedraggable';

export default {
  data() {
    return {
      nav: new FeatureNav(this.$bus),
      preview: false,
      course: {},
      user: null,
      blocks: [],
      destroyedBlocks: [],
      showBlockPicker: false,
      unsaved: false,
      showOnboardingModal: false,
      shownReorder: false,
      shownSave: false,
      saveEle: null,
      hoveredBlocks: {},
      instructorEmailDisabled: false,
    };
  },
  components: {
    Block,
    Draggable,
    SyllabusBlockPicker,
    TextBlock,
    TitleBlock,
    SpacerBlock,
    ImageBlock,
    PdfBlock,
    VideoBlock,
    AudioBlock,
    GradingPolicyBlock,
    SessionListBlock,
    CourseworkListBlock,
    InstructorsListBlock,
    CoursePromoBlock,
    CourseLogoBlock
  },
  computed: {
    editorBlocks() {
      return this.blocks.map( (b, i) =>
        Object.assign(
          {},
          b,
          {
            rootData: b.data,
            showReorder: this.shouldShowReorder && i == 1,
            is: `${b.block_type}-block`,
          }
        )
      );
    },
    previewBlocks() {
      return this.blocks.map( b =>
        Object.assign(
          {},
          b,
          {
            rootData: b.data,
            editable: false,
            isEditing: false
          }
        )
      );
    },
    externalPreviewBlocks() {
      return this.previewBlocks.filter( b => b.data.showOnPublicSyllabus );
    },
    saveableBlockData() {
      let data = [];
      for(let i = 0; i < this.blocks.length; i += 1) {
        const block = this.blocks[i];
        data.push({
          id: block.id,
          uuid: block.uuid,
          block_type: block.block_type,
          order: i,
          data: block.data
        });
      }
      return {
        blockData: data,
        destroyedBlocks: this.destroyedBlocks
      };
    },
    shouldShowReorder() {
      return (
        this.blocks.length > 1 &&
        !this.shownReorder
      );
    },
  },
  methods: {
    bindData(data) {
      this.course = data;
      this.user = data.current_user;
      this.instructorEmailDisabled = data.instructor_email_disabled;
      this.showOnboardingModal = !data.shown_syllabus_modal;
      this.shownReorder = data.shown_reorder_tooltip;
      this.shownSave = data.shown_save_tooltip;
    },

    bindBlocks(blocks) {
      this.blocks = blocks 
        .filter( b => b.is_saved )
        .sort( (a, b) => a.order - b.order );

      this.blocks.forEach(( _, i ) => {
        this.$set(this.blocks[i], 'isEditing', false); 
      }); 
    },

    save(callback) {
      const request = new Kadenze.AjaxRequest({
        url: Kadenze.Routes.course_syllabus_path(this.course.id),
        type: 'PATCH',
        data: { blocks: this.saveableBlockData }
      }); 

      request.success( ({ blocks }) => {
        Kadenze.Notice.success( { message: 'Changes Saved Successfully' } );

        this.bindBlocks(blocks);

        this.destroyedBlocks = [];

        this.unsaved = false;

        if (typeof callback == 'function')
          callback();
      });

      request.fail(resp => console.log('fail', resp))
    },

    onAddBlock(type) {
      this.showBlockPicker = false;
      this.addBlock(type);
    },
    addBlock(blockType, blockData = {}) { 
      const block = Object.assign(
        this.defaultBlock(blockType), blockData
      );

      this.blocks.push(block);
      this.unsaved = true;
      this.setBlockEditing(this.blocks.length - 1);
      window.scrollTo(0, document.body.scrollHeight);
    },
    defaultBlock(type) {
      const blockPresentationNames = {
        'audio': 'Audio',
        'course-logo': 'Course Image',
        'coursework-list': 'Coursework List',
        'course-promo': 'Course Promo Video',
        'grading-policy': 'Grading Policy',
        'instructors-list': 'Instructors',
        'pdf': 'PDF Document',
        'image': 'Photo',
        'text': 'Rich Text Editor',
        'title': 'Section Title',
        'session-list': 'Session Schedule',
        'video': 'Video'
      };
      return {
        block_type: type,
        uuid: Kadenze.Util.generateUUID(),
        data: {
          title: blockPresentationNames[type],
          showOnPublicSyllabus: true
        },
        isEditing: true,
        order: this.blocks.length,
      }; 
    },
    cleanBlockForCopy(newBlock) {
      delete newBlock.uuid;
      delete newBlock.id;
      delete newBlock.order;
         
      if(newBlock.data.title) {
        newBlock.data.title += ' Copy';
      } else {
        newBlock.data.title = 'Untitled Block Copy';
      }

      return newBlock;
    },
    copyBlock(key) {
      const index = this.indexForUUID(key);
      const newBlock = this.cleanBlockForCopy(
        JSON.parse(JSON.stringify(this.blocks[index]))
      );
      this.addBlock(this.blocks[index].block_type, newBlock);
    },
    destroyBlock(key) {
      const index = this.indexForUUID(key);
      const id = this.blocks[index].id;
      if (id) { this.destroyedBlocks.push(id); }
      delete this.hoveredBlocks[key];
      this.$delete(this.blocks, index);
      this.unsaved = true;
    },
    onBlockUpdate(block) {
      const index = this.indexForUUID(block.uuid);
      this.blocks[index].data = block.data;
      this.unsaved = true;
    },
    indexForUUID(key) {
      return this.blocks.findIndex(b => b.uuid == key);
    },
    onSetBlockID(data) {
      this.blocks[this.indexForUUID(data.uuid)].id = data.id;
    },
    updateBlockOrder() {
      this.blocks.forEach( (b, i) => b.order = i );
    },
    toggleBlockEditing(index) {
      if ( this.blocks[index].isEditing ) {
        this.blocks[index].isEditing = false;
      } else {
        this.setBlockEditing(index);
      }
    },
    setBlockEditing(index) {
      this.blocks.forEach( (b, i) => {
        if (i != index) { 
          b.isEditing = false; 
        }
      });
      this.blocks[index].isEditing = true;
    },
    blockTableName(b) {
      return `${ s.titleize(s.humanize(b.block_type)) } Block`;
    },
    showSaveTooltip() {
      if ( !this.shownSave ) {
        const t = new Kadenze.Tooltip({
          target: 'i.kf.kf-save',
          template: 'templates/tooltips/syllabus/save',
          position: 'right',
          arrow: true,
          eventIn: null,
          interactive: {
            context: 'syllabus-save',
            order: 0
          }
        });
        t.show();
        // hack to keep tooltip postitioned relative to the left nav save button
        // as tooltip.js will wipe out any classes and inline styles applied in
        // the tooltip template
        $(t.template).css('position', 'fixed');
        this.shownSave = true;
      }
    },
    onSetHover(id) {
      this.hoveredBlocks[id] = true; 
    },
    onUnsetHover(id) {
      delete this.hoveredBlocks[id];
    },
    leftNavData() {
      return [
        {
          icon_class: 'kf-file-3d',
          label: 'Add Block',
          is_active: this.showBlockPicker,
          callback: () => {
            if ( !this.preview ) {
              this.showBlockPicker = true;
            }
          }
        },
        {
          icon_class: 'kf-eye',
          label: 'Preview',
          is_active: this.preview == 'internal',
          callback: () => { 
            if ( this.preview == false ) {
              this.preview = 'internal';
            } else if ( this.preview == 'internal' ) {
              this.preview = false;
            }
          }
        },
        {
          icon_class: 'kf-save',
          label: 'Save',
          is_active: false,
          callback: this.save
        },
        {
          icon_class: 'kf-cog',
          label: 'Settings',
          callback: () => { 
            this.preview = false;
            $('#syllabus-settings').modal().show();
          }
        },
        {
          icon_class: 'kf-exit',
          label: 'Exit',
          is_active: false,
          callback: () => { 
            if ( this.unsaved ) {
              let opts = {
                title:'Are you sure you want to leave?',
                body: 'Some syllabus fields are unsaved. Are you sure you want to exit?',
                cancel_btn_text: 'Return To Builder',
                ok_btn_text: 'Leave Without Saving'
              };
              Kadenze.UIUtil.confirmNavigation(opts.body, Kadenze.Routes.course_path(this.course.slug), opts);
            } else {
              window.location = Kadenze.Routes.course_path(this.course.slug);
            }
          },
        }
      ];
    },
    onClickOutside(e) {
      const shouldToggle = e.target.className !== 'block-picker-link' &&
                           e.target.parentElement.className !== 'block-picker-link' &&
                           Object.keys(this.hoveredBlocks).length == 0;


      if ( shouldToggle ) {
        this.blocks.forEach( b => b.isEditing = false );
      }
    },
    cleanForDestroy() {
      this.nav.clearLeftNav();
      $('#main').off('click', this.onClickOutside);
    }
  },

  watch: {
    preview(val) {
      if ( ( val == 'internal') || (val == 'external' ) ) {
        $('.kl-main__page-wrap').addClass( 'syllabus__internal-preview' );
      } else {
        $('.kl-main__page-wrap').removeClass( 'syllabus__internal-preview' );
      }
    },
  },

  mounted() {
    if (this.course.syllabus_blocks)
      this.bindBlocks(this.course.syllabus_blocks);

    setTimeout(() => {
      this.nav.hideExpandArrow();
      this.nav.renderLeftNav(this.leftNavData());
    }, 100);

    setTimeout(() => this.saveEle = $('i.kf.kf-save')[0], 200);

    this.$nextTick( () => {
      Kadenze.UIUtil.hideLoadingIndicator(); 
      this.unsaved = false;
    });

    $('#main').on('click', this.onClickOutside);

    $(document).on('pjax:start', () => {
      this.cleanForDestroy();
    });
  },

  destroyed() {
    this.cleanForDestroy();
  }
};
